export default __webpack_public_path__ + "images/walmart-spark-icon.png";